import { Box, styled, Typography } from '@mui/material'

function Closed() {
  return (
    <>
      <StyledBox>
        <Typography variant="h4">PHD Application Forms are closed !</Typography>
        <Typography>
          (If you have any queries please contact us at
          auphdadmissions@anurag.edu.in) Contact numbers - 7032416498
        </Typography>
      </StyledBox>
    </>
  )
}

export default Closed

const StyledBox = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  height: '80vh',
  width: '100%',
}))
